// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-1"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M22 21.0004V3H18V21.0004H22Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M2 20.9994V2.99902H6V20.9994H2Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7.99927C8 7.99927 6 5.99927 6 5.99927V15.9993H18V5.99927C18 5.99927 16 7.99927 12 7.99927ZM12 7.99927V15.999M22 3V21.0004H18V3H22ZM2 2.99902V20.9994H6V2.99902H2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-1',
    ref,
    icon: element,
  },
));

Bridge1Icon.displayName = 'Bridge1Icon';

export default Bridge1Icon;
